import { theme } from "@tm/utility/global";
import styled from "styled-components";

// export const LandingButtonStyle = styled.button<ButtonInterface>`
//   ${(props) =>
//     props.disableState &&
//     `
//   background: ${theme.greyText2};
//   color: rgba(0, 0, 0, 0.3);
//   pointer-events:none;
//   `}
//   span {
//     font-size: ${(p) => (p.fontSize ? p.fontSize : "16px")};
//     font-weight: 900;
//     flex-shrink: 0;
//     color: #fff;
//     overflow: hidden;
//     text-overflow: ellipsis;
//     white-space: nowrap;
//     max-width: 100%;
//   }
// `;

export const ButtonContainer = styled.div`
  background-image: ${theme.blueGradient};
  border-radius: 8px;
  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.21);
  color: #fff;
  width: "fit-content";
  height: "fit-content";
  border: none;
  outline: none;
  cursor: pointer;
  position: relative;
  padding: 12px 20px;
  text-transform: uppercase;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
